import React, { useEffect, useState } from "react";
import { TableSelectColorMap, TableSelectWithOperationsProps } from "./tableSelectWithOperations.types";
import "./styles.scss";
import { TrashIcon } from "../../icons/trash";

export const TableSelectWithOperations: React.FC<TableSelectWithOperationsProps> = ({ ...props }) => {
    const [selected, setSelected] = useState<string[]>([]);
    const selectedColor = TableSelectColorMap.get(props.color ? props.color : 'green')
    const isDisabled = (value: string) =>
        props.disabledValues?.includes(value);

    const handleOnCheckboxClick = (value: string) => {
        if (isDisabled(value)) return;
        let currSelected = [...selected];
        if (currSelected.includes(value)) {
            currSelected = currSelected.filter(c => c !== value);
        } else {
            currSelected.push(value);
        }
        props.onChange && props.onChange(currSelected);
        setSelected(currSelected);
    };

    const handleOnRadioClick = (value: string) => {
        if (isDisabled(value)) return;
        const currSelected = selected.includes(value) ? [] : [value];
        setSelected(currSelected);
        props.onChange && props.onChange(currSelected);
    };

    useEffect(() => {
        if (props.defaultValue)
            setSelected(props.defaultValue)
        if (props.value)
            setSelected(props.value)
    }, [props.value])

    return (
        <div>
            <table id="table-select-withOperations" className="w-[100%]" style={{ backgroundColor: selectedColor?.contentColor }}>
                <thead className="h-[30px] uppercase">
                    <tr>
                        <th className="width-[40px] rounded-tl-[12px]"></th>
                        {props.headers.map((h, idx) => (
                            <th key={idx}>{h}</th>
                        ))}
                        <th className="width-[40px] rounded-tr-[12px]"></th>
                    </tr>
                </thead>
                <tbody>
                    {props.data &&
                        props.data.map((d, index) => (
                            <tr
                                key={index}
                                style={{
                                    color: selectedColor?.contentColor,
                                    background:
                                        index % 2 === 0 ? selectedColor?.borderColor : "#FFFFFF",
                                }}
                            >
                                <td>
                                    <button onClick={() => {
                                        console.log()
                                    }} className='ml-3'>
                                        <TrashIcon color='red' size={20} />
                                    </button>
                                    <TrashIcon color={""} size={0} />
                                </td>
                                {d.labels.map((label, idx) => (
                                    <td key={idx}>{label}</td>
                                ))}
                                <td></td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );
};
